<template>
  <el-dialog :visible.sync="showDialog" :show-close="false" width="30%">
    <div class="dialog-conainer">
      <div class="top-box">
        <div class="title">登录密码</div>
        <div class="img-box" @click="showDialog = false">
          <img class="image" src="@/assets/icon_dialog_close.png" />
        </div>
      </div>
      <el-form
        class="el-form"
        ref="form"
        label-width="105px"
        label-position="right"
        size="small"
        :rules="rules"
        :model="form"
      >
        <el-form-item class="form-content" size="small" label="账户：">
          <div class="account">{{ form.phone }}</div>
        </el-form-item>
        <el-form-item
          class="form-content"
          style="margin-top: -20px"
          size="small"
          label="验证码："
          prop="securityCode"
        >
          <div class="verification-code">
            <el-input
              :readonly="readonly"
              @click.native="handlerIptClick"
              autocomplete="off"
              v-model="form.securityCode"
              clearable
              placeholder="请输入验证码"
            ></el-input>
            <div class="get-code" @click="onGetCodeClick">
              {{ time >= 60 ? codeText : time + "s" }}
            </div>
          </div>
        </el-form-item>
        <el-form-item
          class="form-content"
          size="small"
          label="输入密码："
          prop="password"
        >
          <el-input
            :readonly="readonly"
            @click.native="handlerIptClick"
            autocomplete="off"
            v-model="form.password"
            clearable
            show-password
            placeholder="请设置登录密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="form-content"
          size="small"
          label="确认密码："
          prop="confirmPassword"
        >
          <el-input
            :readonly="readonly"
            @click.native="handlerIptClick"
            autocomplete="off"
            v-model="form.confirmPassword"
            clearable
            show-password
            placeholder="请确认登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancel" @click="showDialog = false">取 消</div>
        <el-button :loading="loading" class="sure" @click="onSureClick"
          >确 认</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { cookieKeys, getCookieItem, removeToken } from "@/utils/auth.js";
import {
  getSendEditPasswordCode,
  getCustomerEditPwd,
} from "@/api/accountcenter";
import AES from "@/utils/AES.js";
export default {
  name: "LoginPassword",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  data() {
    return {
      readonly: true,
      form: {
        phone: "",
        securityCode: "",
        password: "",
        confirmPassword: "",
      },
      loading: false,
      time: 60,
      codeText: "获取验证码",
      timeinterval: undefined,
      rules: {
        securityCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请设置登录密码", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认登录密码", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.form = {
      ...this.form,
      phone: getCookieItem(cookieKeys.phone),
    };
  },
  beforeDestroy() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
    }
  },
  methods: {
    handlerIptClick() {
      this.readonly = false;
    },
    //获取验证码
    onGetCodeClick() {
      if (this.time < 60) return;
      this.time--;
      this.timeinterval = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(this.timeinterval);
          this.time = 60;
          this.codeText = "重新获取";
        }
      }, 1000);
      this._getSendEditPasswordCode();
    },
    onSureClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this._getCustomerEditPwd();
        } else {
          return false;
        }
      });
    },
    //发送修改密码验证码
    _getSendEditPasswordCode() {
      getSendEditPasswordCode()
        .then((res) => {
          const { message } = res;
          this.$message.success(message || "发送成功");
        })
        .catch(() => {});
    },
    //修改密码
    _getCustomerEditPwd() {
      const { password, confirmPassword } = this.form;
      if (password !== confirmPassword) {
        this.$message.error("两次密码输入不一致");
        return;
      }
      this.loading = true;
      getCustomerEditPwd({
        ...this.form,
        password: AES.encrypt(password),
        confirmPassword: AES.encrypt(confirmPassword),
      })
        .then((res) => {
          this.loading = false;
          const { message } = res;
          this.$message.success(message || "修改成功");
          removeToken();
          this.$router.replace("/");
          location.reload();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: 8px;
}
.dialog-conainer {
  margin-top: -45px;
  .top-box {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
    margin-left: -20px;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: -20px;
    .title {
      font-size: 18px;
      color: #333333;
    }
    .img-box {
      cursor: pointer;
      .image {
        width: 28px;
        height: 28px;
      }
    }
  }
  .el-form {
    margin-top: 20px;
    .form-content {
      margin-left: 20px;
      margin-right: 50px;
      margin-bottom: 30px;
      margin-top: -10px;
      .account {
        text-align: left;
      }
    }
    .verification-code {
      display: flex;
      .get-code {
        width: 90px;
        margin-left: -2px;
        height: 32px;
        cursor: pointer;
        font-size: 12px;
        color: #ffffff;
        background-color: #1082ff;
        border-radius: 0px 4px 4px 0px;
        z-index: 99;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .cancel {
      width: 100px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #1082ff;
      font-size: 16px;
      color: #1082ff;
      line-height: 32px;
      margin-right: 10px;
      cursor: pointer;
    }
    .sure {
      width: 100px;
      margin-left: 10px;
      cursor: pointer;
      height: 34px;
      background: #1082ff;
      border-radius: 4px;
      border: 1px solid #1082ff;
      font-size: 16px;
      color: #ffffff;
      line-height: 34px;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountcenter/components/loginpassword.vue